
export const partnerLevelsDispatcher = {
    NOVICE: {value: "Новичок"},
    MIDDLE: {value: "Средний"},
    TOP: {value: "Топ"},
};